export var WidgetDataType;
(function (WidgetDataType) {
    WidgetDataType["RECOMMENDATION"] = "recommendation";
    WidgetDataType["PREVIEW_SEARCH"] = "preview_search";
    WidgetDataType["SEARCH_RESULTS"] = "content_grid";
    WidgetDataType["CONTENT_BLOCK"] = "content_block";
    WidgetDataType["QUESTIONS"] = "questions_answers";
    WidgetDataType["HTML_BLOCK"] = "html_block";
    WidgetDataType["BANNER"] = "banner";
    WidgetDataType["SEO"] = "seo";
})(WidgetDataType || (WidgetDataType = {}));
